import { render, staticRenderFns } from "./PatientList.vue?vue&type=template&id=e0b56db0"
import script from "./PatientList.js?vue&type=script&lang=js&external"
export * from "./PatientList.js?vue&type=script&lang=js&external"
import style0 from "./PatientList.vue?vue&type=style&index=0&id=e0b56db0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports